import script from "./Leaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Leaderboard.vue?vue&type=script&setup=true&lang=js"

import "./Leaderboard.vue?vue&type=style&index=0&id=5797d436&lang=scss"

const __exports__ = script;

export default __exports__